module.exports = __webpack_public_path__ + "img/athletics_icon_5.eaf791ee.png";